var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.905mm",
    height: "14.121mm",
    viewBox: "0 0 10.905 14.121",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-115.53 -116.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.49 116.81h-6.9982c-1.4367 0-2.3812 1.4975-1.7648 2.794l4.8604 10.213c0.32279 0.67998 1.0107 1.1139 1.7648 1.1139h2.1352c1.0795 0 1.9526-0.87577 1.9526-1.9526v-10.213c3e-3 -1.0822-0.87312-1.9553-1.95-1.9553z",
    fill: "#0083c1",
    strokeWidth: 0.26458
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApos);
export default __webpack_public_path__ + "static/media/apos.8879bf34e750ca567a9882f49af793bd.svg";
export { ForwardRef as ReactComponent };